export const isNotStopPropagation = (target: EventTarget) =>
  (target as HTMLElement).getAttribute('data-stop-propagation') !== 'true' &&
  !(target as HTMLElement).closest('[data-stop-propagation=true]')
